export default __webpack_public_path__ + "static/media/mike_frassinelli_modal.dbe47dbe.jpg";